import { useCallback, useEffect, useState } from "react";
import { update } from "../../../acions/userDataCheck";
import { getFormatted } from "../../../lib/PhoneFormatter";
import UserDataCheckService from "../../../services/userDataCheck";
import { useAppDispatch } from "../../../store";
import { useRedirectToPortal } from "./redirectToPortal";
import jwtDecode from "jwt-decode";

export const useUserDataCheck = () => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [isFormDisabled, setIsFormDisabled] = useState(false);

  const [data, setData] = useState<any>({});

  const [phone, setPhone] = useState<string | null>(null);

  const { redirect } = useRedirectToPortal();

  useEffect(() => {
    const { phone } = data;
    setPhone(phone ? getFormatted(phone).slice(2) : null);
  }, [data]);

  useEffect(() => {
    UserDataCheckService.get()
      .then((res) => {
        setData(res);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  const updateData = useCallback(
    async (values: any) => {
      try {
        setIsFormDisabled(true);

        const request = {
          ...values,
          newPassword: values.password,
          phone: `1${values.phone.replace(/[\s-()]/g, "")}`,
        };

        if (!data.isUsernameChangeRequired) {
          delete request.newUsername;
        }

        const res: any = await Promise.resolve(dispatch(update(request)));

        setIsFormDisabled(false);

        const tokenData: any = res.token ? jwtDecode(res.token) : {};

        redirect(tokenData);
      } catch {
        setIsFormDisabled(false);
      }
    },
    [data, dispatch, redirect],
  );

  return { data, isLoading, phone, isFormDisabled, updateData };
};
